import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=56b95939&scoped=true"
import script from "../js/Reports/index?vue&type=script&lang=js&external"
export * from "../js/Reports/index?vue&type=script&lang=js&external"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=56b95939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b95939",
  null
  
)

export default component.exports